module.exports = __webpack_public_path__ + "static/media/bulk_load.df7322de.png";